/**
 * Telt per deelnemer bij hoeveel outputregistraties die deelnemer gekoppeld is.
 *
 * Leest `Participants` op de outputregels zelf. Registraties van vóór
 * 2026-08-25 hebben dat veld niet en tellen dus niet mee — die staan nog in de
 * oude losse deelnemerregistraties.
 *
 * @param {Array<{Participants?: string[]}>} records - EventResults van type 'outputs'
 * @returns {Array<{personaId: string, count: number}>} Aflopend op aantal, daarna op ID
 */
const countParticipantsPerPersona = (records) => {
    const counts = new Map()

    for (const record of records || []) {
        const participants = Array.isArray(record?.Participants) ? record.Participants : []
        for (const personaId of new Set(participants.filter(Boolean))) {
            counts.set(personaId, (counts.get(personaId) || 0) + 1)
        }
    }

    return Array.from(counts.entries())
        .map(([personaId, count]) => ({ personaId, count }))
        .sort((left, right) => {
            if (left.count !== right.count) return right.count - left.count
            return left.personaId.localeCompare(right.personaId)
        })
}

export default countParticipantsPerPersona
